import React from "react";
import { Route } from "react-router-dom";
import { useSelector } from 'react-redux';

import RedirectRenderer from "src/components/redirect-renderer";
import HasFeature from "src/utils/has-feature";
import HasRole from "src/utils/has-role";

import CreditNotes from "./pages/credit-notes";
import CreditNote from "./pages/credit-note";
import CreditNoteCreate from './pages/credit-notes/create';
import Customers from "./pages/customers";
import Customer from "./pages/customer";
import GroupMenu from "src/components/group-menu";
import GroupContainer from "src/components/group-container";

import { PencilSquareIcon, UserGroupIcon } from "@heroicons/react/24/outline";

const Layout = ({ children }) => {
  const { organisation: { features }, account: { account } } = useSelector((state) => state);

  const items = [
    { name: 'Customers', description: 'View and manage your customers', icon: UserGroupIcon, path: '/customers', check: true },
    { name: 'Credit Notes', description: 'Create, view and manage customer credit notes', icon: PencilSquareIcon, path: '/customers/credit-notes', check: HasRole(account, ['credit-notes:view']) && HasFeature(features, ['credit-notes']) },

    { name: 'Customer', description: 'View and manage your customer', parent: 'Customers', icon: UserGroupIcon, path: '/customer/:id', check: true, visible: false },
    { name: 'Customer', description: 'View and manage your customer', parent: 'Customers', icon: UserGroupIcon, path: '/customer/:id/payments', check: true, visible: false },
    { name: 'Customer', description: 'View and manage your customer', parent: 'Customers', icon: UserGroupIcon, path: '/customer/:id/bookings', check: true, visible: false },
    { name: 'Customer', description: 'View and manage your customer', parent: 'Customers', icon: UserGroupIcon, path: '/customer/:id/payment-links', check: true, visible: false },
  ];

  return (
    <div id="content">
      <GroupMenu items={items} title="Customers" />
      <GroupContainer>
        {children}
      </GroupContainer>
    </div>
  )
};

const redirects = [
  { from: '/credit-notes', to: '/customers/credit-notes' },
  { from: '/credit-note/create', to: '/customers/credit-notes/create' },
  { from: '/credit-notes/:id', to: '/customers/credit-note/:id' },
];

const Payments = () => {
  const { organisation: { features }, account: { account } } = useSelector((state) => state);

  if (account?.id) {
    return (
      <React.Fragment>

        {RedirectRenderer({ redirects })}

        {HasFeature(features, ['booking-and-payment']) && (
          <React.Fragment>
            <Route exact path={`/customers`} component={() => <Layout><Customers /></Layout>} />
            <Route exact path={`/customer/:id`} component={() => <Layout><Customer /></Layout>} />
            <Route exact path={`/customer/:id/payments`} component={() => <Layout><Customer /></Layout>} />
            <Route exact path={`/customer/:id/bookings`} component={() => <Layout><Customer /></Layout>} />
            <Route exact path={`/customer/:id/payment-links`} component={() => <Layout><Customer /></Layout>} />
          </React.Fragment>

        )}

        {HasRole(account, ['credit-notes:view']) && HasFeature(features, ['credit-notes']) && (
          <React.Fragment>
            <Route exact path={`/customers/credit-notes`} component={() => <Layout><CreditNotes /></Layout>} />
            <Route exact path={`/customers/credit-note/:id`} component={() => <Layout><CreditNote /></Layout>} />
          </React.Fragment>
        )}

        {HasRole(account, ['credit-notes:create']) && HasFeature(features, ['credit-notes']) && (
          <Route exact path={`/customers/credit-notes/create`} component={() => <Layout><CreditNoteCreate /></Layout>} />
        )}

      </React.Fragment>
    );
  }

  return <React.Fragment />;
};

export default Payments;
